/* Noorns redesign: which sign-up box says "thanks" after the page reloads (2026-10-11).

   Shopify sends a customer form the normal way and reloads the page with ?customer_posted=true,
   which marks every customer form on the page as posted. So the footer box and the example
   box both drew their thanks whatever was used, and because the page reloads at the top, the
   footer's thanks sat out of sight and the footer box looked dead.

   The forms now draw the thanks with the form kept underneath it, hidden (data-posted-done,
   data-posted-ask). This script remembers which form was sent, then after the reload keeps the
   thanks only on that form, shows the plain form again on the others, and scrolls to the thanks.
   If the browser blocks session storage, the page stays as Shopify drew it. Loaded once from the
   footer, which is on every page. */
(function () {
  if (window.__noornsPosted) return;
  window.__noornsPosted = true;
  var KEY = 'noorns-posted-form';

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.id || !form.querySelector('input[name="contact[email]"]')) return;
    try { sessionStorage.setItem(KEY, form.id); } catch (_) {}
  });

  function ready() {
    var dones = document.querySelectorAll('[data-posted-done]');
    if (!dones.length) return;
    var used = null;
    try { used = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (_) {}
    if (!used) return;
    var keep = null;
    dones.forEach(function (done) {
      var form = done.closest('form');
      var ask = form && form.querySelector('[data-posted-ask]');
      if (form && form.id === used) {
        keep = done;
      } else {
        done.hidden = true;
        done.style.display = 'none'; // some page styles set .xr-done to flex, which beats [hidden]
        if (ask) ask.hidden = false;
      }
    });
    if (keep) {
      keep.scrollIntoView({ block: 'center' });
      try { keep.focus({ preventScroll: true }); } catch (_) {}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
